import { FiAlignLeft } from 'react-icons/fi';

import Textarea from '@components/Textarea';

import { FieldRendererProps } from '../types';

const TextareaField = ({ field, disabled }: FieldRendererProps) => (
  <Textarea
    name={field.name}
    placeholder={field.placeholder || field.label}
    icon={FiAlignLeft}
    disabled={disabled}
    required={field.is_required}
  />
);

export default TextareaField;
